import { windowWidth } from './utils';

const HOVER_DELAY = 250;

const headerHoverPopups = {
  btns: Array.from(
    document.querySelectorAll('.jsPopupBtns'),
  ) as HTMLElement[],

  wraps: Array.from(
    document.querySelectorAll('.jsPopupWraps'),
  ) as HTMLElement[],

  overlay: document.getElementById('jsPopupOverlay') as HTMLElement | null,

  openTimer: null as ReturnType<typeof setTimeout> | null,

  init() {
    if (windowWidth > 1200) {
      this.setHoverState();
      this.removeHoverState();
    }

    this.setClosePopupListener();
  },

  setHoverState() {
    this.btns.forEach((btn) => {
      btn.addEventListener('mouseenter', () => {
        this.handleHover(btn);
      });

      btn.addEventListener('mouseleave', () => {
        this.clearOpenTimer();
      });
    });

    this.wraps.forEach((wrap) => {
      wrap.addEventListener('mouseenter', () => {
        this.clearOpenTimer();
      });
    });
  },

  handleHover(activeBtn: HTMLElement) {
    const popupId = activeBtn.getAttribute('data-popup');

    this.clearOpenTimer();

    this.openTimer = setTimeout(() => {
      this.btns.forEach((btn) => {
        const wrap = this.getWrapForButton(btn);
        const isActive = btn.getAttribute('data-popup') === popupId;

        btn.classList.toggle('activeClass', isActive);

        if (wrap) {
          wrap.classList.toggle('activeClass', isActive);
        }
      });

      if (this.overlay) {
        this.overlay.classList.add('activeClass');
      }

      this.openTimer = null;
    }, HOVER_DELAY);
  },

  getWrapForButton(btn: HTMLElement): HTMLElement | null {
    const btnPopupId = btn.getAttribute('data-popup');

    return (
      this.wraps.find(
        (wrap) => wrap.getAttribute('data-popup') === btnPopupId,
      ) || null
    );
  },

  removeHoverState() {
    window.addEventListener('mouseover', (event) => {
      this.handleMouseOut(event);
    });
  },

  handleMouseOut(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (!this.isHoveredElement(target)) {
      this.clearOpenTimer();
      this.closePopups();
    }
  },

  isHoveredElement(target: HTMLElement): boolean {
    return [...this.btns, ...this.wraps].some(
      (element) => element === target || element.contains(target),
    );
  },

  clearOpenTimer() {
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }
  },

  setClosePopupListener() {
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.closePopups();
      });
    }

    const closeButtons =
      document.querySelectorAll<HTMLElement>('.close-popup');

    closeButtons.forEach((closeBtn) => {
      closeBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        this.closePopups();
      });
    });
  },

  closePopups() {
    this.clearOpenTimer();

    this.btns.forEach((btn) => {
      btn.classList.remove('activeClass');
    });

    this.wraps.forEach((wrap) => {
      wrap.classList.remove('activeClass');
    });

    if (this.overlay) {
      this.overlay.classList.remove('activeClass');
    }
  },
};

export default headerHoverPopups;